// HORA — l'unité des SKILLCARDS et la méthode qu'elles enseignent.
//
// Unité : ce que gagne une CARTE quand l'élève répond juste à une question
// reliée. C'est un simple nom d'affichage : les colonnes SQL restent `xp_max`,
// `question_xp`, `student_cards.xp` (renommer casserait les RPC et les apps
// natives déjà publiées). L'XP de l'ÉLÈVE (profil, séries, Live) reste l'XP.
//
// Méthode : Hypothèse → Outil → Raisonnement → Application, affichée sur la
// landing, la page /skillcards et la page publique d'une carte.

/** Nom de l'unité des cartes, à afficher partout à la place de « XP ». */
export const HORA_UNIT = 'HORA';

/** « 1 500 HORA » (groupes de milliers, espace insécable). */
export function formatHora(value: number): string {
  const n = Number.isFinite(value) ? Math.max(0, Math.round(value)) : 0;
  const grouped = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
  return `${grouped}\u00A0${HORA_UNIT}`;
}

/** « +30 HORA ». */
export function formatHoraGain(value: number): string {
  return `+${formatHora(value)}`;
}

export type HoraStepKey = 'H' | 'O' | 'R' | 'A';

export interface HoraStep {
  key: HoraStepKey;
  title: string;
  description: string;
  /** Teinte d'accent (hex) — identique app et marketing. */
  color: string;
}

/** Les 4 temps de la méthode HORA, dans l'ordre. */
export const HORA_METHOD: readonly HoraStep[] = [
  {
    key: 'H',
    title: 'Hypothèse',
    description: 'Je comprends l’énoncé, j’identifie ce qu’on cherche et les informations données.',
    color: '#3b5bdb',
  },
  {
    key: 'O',
    title: 'Outil',
    description:
      'Je choisis l’outil mathématique adapté (définition, propriété, théorème, formule…).',
    color: '#2f9e44',
  },
  {
    key: 'R',
    title: 'Raisonnement',
    description: 'Je justifie pourquoi cet outil est pertinent et je construis ma démarche.',
    color: '#f08c00',
  },
  {
    key: 'A',
    title: 'Application',
    description: 'J’applique la méthode au problème et je conclus en vérifiant le résultat.',
    color: '#e03131',
  },
] as const;
